module.exports = __webpack_public_path__ + "img/desktop-neck-7_262x18.bccbfc24.png";